export default __webpack_public_path__ + "static/media/fad-zoomin.5022bcd5.svg";